import React, { useEffect, useState } from 'react'
import ApiClient from '../../common/ApiClient';
import { useLocation, useParams, useNavigate } from 'react-router-dom';



import Typography from '@mui/material/Typography';
import AlertMessage from '../../AlertMessage';

import Failure from "../../../images/Failure.png"
import Pending from "../../../images/Pending.png"
import { Grid } from '@mui/material'
import Box from '@mui/material/Box';
import { TextField } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { FormControl } from '@mui/material';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import dayjs from 'dayjs';
import { handleKeyDown, isTimeUp } from '../../Helper';


const DeclarationAndPayment = ({ formData, setFormData }) => {
    const [currentDate, setCurrentDate] = useState('');

    const { id = null, response = null } = useParams();
    const [errors, setErrors] = useState({});

    const [checkboxes, setCheckboxes] = useState({
        checkbox1: false,
        checkbox2: false,
        checkbox4: false,
    });
    const handleCheckboxChange = (e) => {
        const { id, checked } = e.target;
        setCheckboxes({
            ...checkboxes,
            [id]: checked,
        });
    };
    const allChecked = Object.values(checkboxes).every(Boolean);
    const { postRequest, getRequest, deleteRequest } = ApiClient();
    const dashboardnavi = useNavigate();
    const [paymentMessage, setPaymentMessage] = useState('');
    const [paymentResponse, setPaymentResponse] = useState(response);
    const [alertData, setAlertData] = useState({
        heading: "",
        content: ""
    });
    const generatePaymentMsg = async () => {

        const predata = await postRequest('ott/go_to_payment', { last_id: id });

        if (predata.status) {
            // console.log(predata.data.msg)
            setPaymentMessage(predata.data.msg);
        }
        //  console.log({ paymentMessage });
    }
    const search = useLocation().search;
    const daata = new URLSearchParams(search).get("response");

    const paymentResponseLastTransation = async () => {


        if (daata === 'pending') {
            setAlertData({
                heading: "Payment Status",
                content: (<>
                    <p style={{ display: "flex", justifyContent: "center" }}><img src={Pending} alt='' width="60px" height="60px" /> </p>
                    <h4 style={{ display: 'flex', justifyContent: "center" }}>Transaction Pending</h4>
                    <Typography gutterBottom >
                        <p style={{ textAlign: "center", marginTop: "10px" }} className='text-center'> Your transaction is currently in pending. We're working to process it as quickly as possible. Thanks for your patience! </p>
                    </Typography>
                </>)
            });
            handleClickOpen();
        }
        if (daata === 'failed') {
            setAlertData({
                heading: "Payment Status",
                content: (<>
                    <p style={{ display: "flex", justifyContent: "center" }}><img src={Failure} alt='' width="78px" height="78px" /> </p>
                    <h4 style={{ display: 'flex', justifyContent: "center" }}>Payment Failed</h4>
                    <Typography gutterBottom >
                        <p style={{ textAlign: "center", marginTop: "10px" }} className='text-center'> We regret to inform you that your payment has failed to process. Please review your payment details and try again. </p>
                    </Typography>
                </>)
            });
            handleClickOpen();
        }

    }
    useEffect(() => {
        const date = new Date();
        const formattedDate = `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`;
        setCurrentDate(formattedDate);
        paymentResponseLastTransation()
        generatePaymentMsg();
        // Load BillDesk script dynamically
        const script = document.createElement('script');
        script.src = 'https://pgi.billdesk.com/payments-checkout-widget/src/app.bundle.js';
        script.async = true;
        script.onload = () => {
            // Script has been loaded, now you can use bdPayment
            // console.log('BillDesk script loaded');
        };
        document.body.appendChild(script);

        // Cleanup function
        return () => {
            document.body.removeChild(script);
        };
    }, []);

    const validateValues = (inputValues) => {
        // console.log({ inputValues })
        const { name_of_the_applicant, date, email, contact_number, designation } = inputValues;
        let errors = {};
        if (!name_of_the_applicant) errors.name_of_the_applicant = "Enter your name";
        if (!designation) errors.designation = "Enter your Designation";

        // if (mobile.length < 10) errors.mobile = "Mobile number is too short";
        if (!contact_number) {
            errors.contact_number = "Enter your phone number";
        } else {
            if (contact_number.length < 10) {
                errors.contact_number = "Mobile number must be of 10 digits.";
            }

        }
        if (!email) {
            errors.email = "Enter your Email ID.";
        } else {
            if (email.length < 10) errors.email = "Email is too short";
            if (!email.match(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i)) errors.email = "Invalid email format";

        }

        return errors;
    };
    const updateDeclaration = async () => {
        // console.log({ formData });

        // Validate the form data
        const formErrors = validateValues(formData);
        setErrors(formErrors);

        // Check if there are any errors
        if (Object.keys(formErrors).length > 0) {
            // If there are errors, do not proceed further
            // console.log('Form validation failed:', formErrors);
            return false;
        }


        const updatedFormData = {
            ...formData,
            step: 7,
        };
        const producer_data_check = await postRequest(`ott/${id}`, updatedFormData);


        setFormData({
            date: null,

        });
        if (producer_data_check.status) {
            return true
        } else {
            alert(producer_data_check.message)
        }
        return false;

    }
    const processToPay = async (e) => {

        // console.log({ SERVER_URL: process.env.REACT_APP_BASE_URL });
        const updateDeclarationvalue = await updateDeclaration();
        if (!updateDeclarationvalue) {
            return false;
        }
        if (window.bdPayment) {
            // console.log('Pay Msg : : ', paymentMessage);
            window.bdPayment.initialize({
                "msg": paymentMessage,//"NFDCLTD|NFAI-FCM-64|NA|1770.00|NA|NA|NA|INR|NA|R|nfdcltd|NA|NA|F|abhisheksrivastava0022@gmail.com|7985430710|NFAI|Abhishek Srivastava|NFAI-FCM-64|NA|NA|NA|4449748D363C5227F532121F004C3CFBD09F9AEBCCCE7334F7C5FB61F77E2821",
                "options": {
                    "enableChildWindowPosting": true,
                    "enablePaymentRetry": true,
                    "retry_attempt_count": 3
                },
                "callbackUrl": `${process.env.REACT_APP_BASE_URL}/ott/payment-response`
            });
        } else {
            console.error('BillDesk script not loaded yet');
        }
    }
    const targetDateString = process.env.REACT_APP_TARGET_DATE; // Date from the .env file
    const timeUp = isTimeUp(targetDateString); // Check if the time is up
    const timeUpHandler = () => {
        if (timeUp) {
            alert('Time is up! You can no longer proceed.');
            dashboardnavi("/dashboard/ott");
        } else {
            // You can show an alert or handle the "time up" condition differently here
            processToPay(); // Proceed with handleComplete if time is not up

        }
    };

    const fetchPaymentStatus = async () => {
        try {
            // const response = await axios.get('http://localhost:3001/api/payment/status'); // Your endpoint to check payment status
            //setPaymentStatus(response.data);
        } catch (error) {
            console.error('Error fetching payment status:', error);
        }
    };

    const [open, setOpen] = React.useState(false);

    const handleClickOpen = () => {
        // console.log("handleClickOpen");
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
        errors[name] = ""
        setErrors(errors);
    };


    return (
        <>
            <h5 className=" payment">
                10. I/We give consent to screen the web series for consideration for Best Web Series (OTT) Award.
            </h5>


            <form>
                <div className='container'>
                    <div className='row'>
                        <div className='col-sm-12 col-lg-12'>
                            <div className='form-check'>
                                <input
                                    className='form-check-input'
                                    type='checkbox'
                                    id='checkbox1'
                                    name='checkbox1'
                                    checked={checkboxes.checkbox1}
                                    onChange={handleCheckboxChange}
                                />
                                <label className='form-check-label' htmlFor='checkbox1'>
                                    <p className='declar'>I/we have No objection to the screening of this web series for the preview committee, jury, or any of their panels, as well as the use of web series stills/posters, trailers/visual clips by the Ministry of Information and Broadcasting, Government of India, for the purpose of promoting the International Film Festival of India (IFFI) or any other associated events.</p>
                                </label>
                            </div>
                        </div>
                        <div className='col-sm-12 col-lg-12'>
                            <div className='form-check'>
                                <input
                                    className='form-check-input'
                                    type='checkbox'
                                    id='checkbox2'
                                    name='checkbox2'
                                    checked={checkboxes.checkbox2}
                                    onChange={handleCheckboxChange}
                                />
                                <label className='form-check-label' htmlFor='checkbox2'>
                                    <p className='declar'>I/we declare that I/we have read the Best web series (OTT) Award Regulations and accept them without reservation. In particular, I/we note the conditions of Clause 6.5 of the Regulations stipulating that my/our entry will be rejected unless the entry form along with all the required material is received by the Ministry of Information and Broadcasting, Government of India on or before submission deadline.</p>
                                </label>
                            </div>
                        </div>
                        <div className='col-sm-12 col-lg-12'>
                           
                        </div>
                        <div className='col-sm-12 col-lg-12'>
                            <div className='form-check'>
                                <input
                                    className='form-check-input'
                                    type='checkbox'
                                    id='checkbox4'
                                    name='checkbox4'
                                    checked={checkboxes.checkbox4}
                                    onChange={handleCheckboxChange}
                                />
                                <label className='form-check-label' htmlFor='checkbox4'>
                                    <p className='declar'>I/We hereby declare that the information provided is true to the best of my/our knowledge and corresponds with the credit titles of the web series. I/we also understand that the Ministry of Information and Broadcasting, Government of India has the right to reject any entry at any stage, if the information entered in this form is found to be incomplete or incorrect.</p>
                                </label>
                            </div>
                        </div>
                    </div>
                </div>


                <Grid container spacing={2} className='mt-4'>


                    <Grid item xs={12} sm={12} md={12} lg={12}>
                        <h5>
                            Name of the Applicant
                        </h5>
                    </Grid>

                    <Grid item xs={12} sm={12} md={6} lg={6}>
                        <Box>
                            <TextField
                                id="name_of_the_applicant"
                                type="text"
                                label="Name of the applicant"
                                fullWidth
                                name="name_of_the_applicant"
                                value={formData.name_of_the_applicant}
                                onChange={handleChange}
                                  InputLabelProps={{ shrink: true }}
                                 
                            />
                        </Box>
                        {errors.name_of_the_applicant && <p className="error-msg text-danger">{errors.name_of_the_applicant}</p>}
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={6}>
                        <Box>
                            <TextField
                                id="date"
                                label="Date"
                                fullWidth
                                name="date"
                                value={currentDate}
                                InputProps={{
                                    readOnly: true,
                                }}
                            />
                        </Box>

                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={6}>
                        <Box>
                            <TextField
                                id="email"
                                type="email"
                                label="E-mail"
                                fullWidth
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                                  InputLabelProps={{ shrink: true }}
                            />
                        </Box>
                        {errors.email && <p className="error-msg text-danger">{errors.email}</p>}
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={6}>
                        <Box>
                            <TextField
                                id="contact_number"
                                type="number"
                                label="Contact Number"
                                fullWidth
                                name="contact_number"
                                value={formData.contact_number}
                                onChange={handleChange}
                                onKeyDown={handleKeyDown}
                                onInput={(e) => {
                                    if (e.target.value.length > 10) e.target.value = e.target.value.slice(0, 10);
                                }}
                                  InputLabelProps={{ shrink: true }}
                            />
                        </Box>
                        {errors.contact_number && <p className="error-msg text-danger">{errors.contact_number}</p>}
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={6}>
                        <Box>
                            <TextField
                                id="Designation"
                                type="text"
                                label="Designation"
                                fullWidth
                                name="designation"
                                value={formData.designation}
                                onChange={handleChange}
                                  InputLabelProps={{ shrink: true }}
                            />
                        </Box>
                        {errors.designation && <p className="error-msg text-danger">{errors.designation}</p>}
                    </Grid>
                </Grid>



                <div className='row mt-4'>
                    <div className='col-sm-12 col-lg-12'>
                        <p className='text-uppercase' style={{ color: '#FF0000', fontWeight: "500" }}>Note: check all the details of form before final submission</p>
                    </div>
                </div>


            </form>
            <button className='btn btn-success' onClick={timeUpHandler} disabled={!allChecked}>Pay & Submit</button>

            <AlertMessage handleClickOpen={handleClickOpen} setOpen={setOpen} open={open} handleClose={handleClose}

                data={alertData}
            />

        </>
    )
}

export default DeclarationAndPayment